// extracted by mini-css-extract-plugin
module.exports = {"root":"IconList_root__1uMCq","item":"IconList_item__1PU90","value":"IconList_value__S_Zjd","valueSuffix":"IconList_valueSuffix__IZbPa","wrapper":"IconList_wrapper__iW-Oc"};